import { combineReducers } from 'redux';
import {configureStore, createSlice} from "@reduxjs/toolkit";

// import CompanyReducer, { CompanyState } from './Company';

// const rootReducer = combineReducers<RootState>({
//   // company: CompanyReducer,
// });
//
// export interface RootState {
//   // company: CompanyState;
// }

// Define a type for the slice state
interface CounterState {
    value: number
}

// Define the initial state using that type
const initialState: CounterState = {
    value: 0,
}
const reducerSlice = createSlice({
    name: 'rootReducer',
    initialState: {value: 0},
    reducers: {
        increment(state:CounterState): any {
            state.value++
        },
    }
})

export const rootReducer = reducerSlice.reducer
//
// export const rootReducer = configureStore({
//     reducer: {
//         someReducer: reducerSlice.reducer,
//     }
// })